import { useEffect, useState } from 'react';
import { subscribeToSession, signOut, type ArcanumSession } from './services/auth.service';
import { LoginPage } from './pages/LoginPage';
import { PipelinePage } from './pages/PipelinePage';

export default function App() {
  const [session, setSession] = useState<ArcanumSession | null | undefined>(undefined);

  useEffect(() => subscribeToSession(setSession), []);

  if (session === undefined) {
    return <div className="min-h-screen flex items-center justify-center text-gray-400 text-sm">Caricamento…</div>;
  }

  if (session === null) {
    return <LoginPage />;
  }

  if (!session.isArcanumTeam) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-3 text-center px-4">
        <p className="text-gray-700 font-semibold">Accesso riservato al team Arcanum.</p>
        <button onClick={() => signOut()} className="text-sm text-swiss-red underline">Esci</button>
      </div>
    );
  }

  return <PipelinePage currentUid={session.user.uid} arcanumLevel={session.arcanumLevel} />;
}
